module.exports = __webpack_public_path__ + "img/3.3ab4794f.jpg";